export const DEFAULT_VERBOSITY = 'comprehensive';
export const verbosityOptions = [
  { value: 'comprehensive', label: 'Comprehensive' },
  { value: 'balanced', label: 'Balanced' },
  { value: 'concise', label: 'Concise' },
];

export const DEFAULT_FORMAT = 'bulleted';
export const formatOptions = [
  { value: 'bulleted', label: 'Bulleted' },
  { value: 'prose', label: 'Prose' },
];
